(() => {
  const node = document.getElementById('VoicskySearchCatalog');
  if (!node) return;
  const catalog = JSON.parse(node.textContent);
  catalog.products = catalog.products.filter((product) => window.voicskyCanViewProduct?.(product.handle) !== false);
  const normalize = (value) => value.normalize('NFKC').toLocaleLowerCase().replace(/voicsky/g, '').replace(/[^\p{L}\p{M}\p{N}]+/gu, ' ').trim();
  const distance = (a, b) => {
    const rows = Array.from({length:a.length + 1}, (_,i) => Array.from({length:b.length + 1}, (_,j) => i === 0 ? j : j === 0 ? i : 0));
    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        rows[i][j] = Math.min(rows[i-1][j] + 1, rows[i][j-1] + 1, rows[i-1][j-1] + (a[i-1] === b[j-1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i-1] === b[j-2] && a[i-2] === b[j-1]) rows[i][j] = Math.min(rows[i][j], rows[i-2][j-2] + 1);
      }
    }
    return rows[a.length][b.length];
  };
  const matchesTitle = (title, raw, allowTypo = false) => {
    const name = normalize(title), query = normalize(raw);
    if (!query) return false;
    if (name.replaceAll(' ', '').includes(query.replaceAll(' ', ''))) return true;
    return query.split(' ').every((word) => name.includes(word) || (allowTypo && word.length >= 4 && name.split(' ').some((part) => distance(part, word) === 1)));
  };
  const titleQuery = (titles) => titles.map((title) => `title:"${title.replace(/["\\]/g, '')}"`).join(' OR ');
  const aliases = { '鍵盤': 'keyboard', '滑鼠': 'mouse', '滑鼠墊': 'mousepad', 'キーボード': 'keyboard', 'マウス': 'mouse', 'マウスパッド': 'mousepad', '키보드': 'keyboard', '마우스': 'mouse', '마우스패드': 'mousepad', 'คีย์บอร์ด': 'keyboard', 'เมาส์': 'mouse', 'แผ่นรองเมาส์': 'mousepad', keyboards: 'keyboard', kb: 'keyboard', '键盘': 'keyboard', mice: 'mouse', '鼠标': 'mouse', 'mouse pad': 'mousepad', mousepads: 'mousepad', '鼠标垫': 'mousepad' };
  const buildQuery = (raw) => {
    if (/[a-z_.]+:|\b(?:AND|OR|NOT)\b/.test(raw)) return raw;
    const normalized = normalize(raw);
    if (!normalized) return raw.trim();
    const category = aliases[normalized] || normalized;
    if (catalog.categories[category]?.length) return titleQuery(catalog.categories[category]);
    let matches = catalog.products.filter((product) => matchesTitle(product.title, raw));
    if (!matches.length) matches = catalog.products.filter((product) => matchesTitle(product.title, raw, true));
    if (matches.length) return titleQuery(matches.map((product) => product.title));
    if (/^vsky[-\s]/i.test(raw)) return `variants.sku:"${raw.replace(/["\\]/g, '')}"`;
    return raw.trim();
  };
  const searchForm = document.querySelector('.search-page-input__parent');
  const smart = searchForm?.dataset.smartSearch !== 'false';
  const current = new URL(location.href);
  const searchPath = searchForm ? new URL(searchForm.action).pathname : `${window.Shopify?.routes?.root || '/'}search`;
  const cleanStatus = (url) => {
    if (document.querySelector('results-list[data-show-prices="false"]')) {
      for (const key of [...url.searchParams.keys()]) if (/^filter\.v\.(availability|price)/.test(key)) url.searchParams.delete(key);
      if (url.searchParams.get('sort_by')?.startsWith('price')) url.searchParams.delete('sort_by');
    }
    return url;
  };
  if (location.pathname === searchPath) {
    const raw = current.searchParams.get('q') || '';
    const query = smart ? buildQuery(raw) : raw;
    const next = cleanStatus(new URL(current));
    if (query !== raw) { next.searchParams.set('q', query); next.searchParams.set('vsk_query', raw); }
    next.searchParams.set('type', 'product');
    next.searchParams.set('options[unavailable_products]', 'show');
    next.searchParams.set('options[prefix]', 'last');
    if (next.href !== current.href) { location.replace(next); return; }
    const display = current.searchParams.get('vsk_query');
    if (display && searchForm) {
      document.title = `${catalog.labels.title.replace('__query__', () => display)} – ${document.title.split(' – ').at(-1)}`;
      searchForm.querySelector('[name="q"]').value = display;
      const message = searchForm.querySelector('.search-results__no-results p');
      if (message) message.textContent = catalog.labels.noResults.replace('__query__', () => display);
      document.querySelectorAll('.voicsky-search-categories a').forEach((link) => {
        const category = new URL(link.href).searchParams.get('q');
        if (category === (aliases[normalize(display)] || normalize(display))) link.setAttribute('aria-current', 'page');
      });
    }
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || new URL(form.action).pathname !== searchPath) return;
    const input = form.querySelector('[name="q"]');
    if (!input) return;
    const raw = input.value.trim();
    const query = smart ? buildQuery(raw) : raw;
    const url = new URL(form.action);
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'show');
    if (query !== raw) url.searchParams.set('vsk_query', raw);
    event.preventDefault();
    location.assign(cleanStatus(url));
  }, true);
  if (!searchForm || searchForm.dataset.predictiveSearch === 'false') return;
  const input = searchForm.querySelector('[name="q"]');
  const suggestions = searchForm.querySelector('.voicsky-search-suggestions');
  suggestions.id = `${input.id}-suggestions`;
  suggestions.setAttribute('aria-label', catalog.labels.suggestions);
  input.setAttribute('aria-controls', suggestions.id);
  input.setAttribute('aria-expanded', 'false');
  const close = () => { suggestions.hidden = true; input.setAttribute('aria-expanded', 'false'); };
  let timer, controller;
  input.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort(); close();
    const query = input.value.trim();
    if (query.length < 2) return;
    timer = setTimeout(async () => {
      controller = new AbortController();
      const url = new URL(`${searchForm.action}/suggest.json`);
      url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '5', 'resources[options][fields]': 'title,variants.sku,variants.barcode', 'resources[options][unavailable_products]': 'show' });
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) return;
        const data = await response.json();
        if (input.value.trim() !== query) return;
        suggestions.replaceChildren();
        for (const product of data.resources.results.products.filter((product) => window.voicskyCanViewProduct?.(product.handle) !== false && matchesTitle(product.title, query, true))) {
          const link = document.createElement('a'); link.href = product.url;
          if (product.image) { const image = document.createElement('img'); image.src = product.image; image.alt = ''; image.loading = 'lazy'; link.append(image); }
          const title = document.createElement('span'); title.textContent = product.title; link.append(title); suggestions.append(link);
        }
        if (suggestions.children.length) { suggestions.hidden = false; input.setAttribute('aria-expanded', 'true'); }
      } catch (error) { if (error.name !== 'AbortError') close(); }
    }, 180);
  });
  input.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); if (event.key === 'ArrowDown' && !suggestions.hidden) { event.preventDefault(); suggestions.querySelector('a')?.focus(); } });
  document.addEventListener('pointerdown', (event) => { if (!searchForm.contains(event.target)) close(); });
  searchForm.addEventListener('focusout', (event) => { if (!searchForm.contains(event.relatedTarget)) close(); });
})();
